"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const DashboardNoDataInfo_1 = __importDefault(require("@Scenes/RightsholderScene/RightsholderDashboard/DashboardNoDataInfo"));
const Button_1 = require("@Components/Buttons/Button");
const navigation_1 = __importDefault(require("@App/navigation"));
const contexts_1 = require("@App/contexts");
require("./index.scss");
const DashboardKpiCard_1 = __importDefault(require("@Scenes/RightsholderScene/RightsholderDashboard/DashboardKpiCard"));
const DashboardWorksKpiCard = ({ data, change }) => {
    const { rightsholderStore } = (0, react_1.useContext)(contexts_1.StoresContext);
    return (react_1.default.createElement(DashboardKpiCard_1.default, { title: 'Your registered works', data: data.toLocaleString('en-US'), className: 'total-works', noDataInfo: !data ? react_1.default.createElement(DashboardNoDataInfo_1.default, { type: 'works', finalWord: 'submitted' }) : undefined }, !data && (react_1.default.createElement("div", { className: 'button-container' },
        react_1.default.createElement(Button_1.Button, { mainColor: true, type: 'primary-small', typeLink: true, linkTo: navigation_1.default.rightholder.createWork.root(rightsholderStore.currentRightsholderId) }, "Register Works")))));
};
exports.default = DashboardWorksKpiCard;
